module.exports = __webpack_public_path__ + "static/media/JoshS.2abfb8f5.webp";